<template>
  <div class="w-full flex flex-col items-center">
    <div class="w-11/12">
      <n-form ref="formRef">
        <n-form-item :label="$t('email-or-phone')">
          <n-input
            @keydown.enter.prevent
            v-model:value="emailOrPhoneNumber"
            :placeholder="$t('email-or-phone')"
          />
        </n-form-item>
      </n-form>
      <div class="mb-5 flex flex-row justify-center floatting bottom-0">
        <n-button
          type="primary"
          size="large"
          @click="login"
          :disabled="emailOrPhoneNumber.length === 0"
          >{{ $t("access-account") }}</n-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import { mapState } from "pinia";
import { authStore } from "@/stores/auth";

export default {
  name: "LoginForm",
  data() {
    return {
      emailOrPhoneNumber: "",
    };
  },
  computed: {
    ...mapState(authStore, ["organization", "passId"]),
  },
  methods: {
    async login() {
      try {
        await api.post(
          `/organization/${this.organization.id}/pass/${this.passId}/login`,
          {
            emailOrPhoneNumber: this.emailOrPhoneNumber,
          }
        );
        this.$router.push({
          name: "recoveryPage",
          query: {
            ...this.$route.query,
          },
        });
      } catch (e) {
        if (e.response.status === 404) {
          this.$notificationGenerator.error(this.$t("user-not-found"));
        } else {
          this.$notificationGenerator.error(this.$t("unexpected-error"));
        }
      }
    },
  },
};
</script>

<style scoped></style>
